import React, { useEffect } from 'react';
import TableContent from '../../Betslip/TableContent';
import { convertSelectionsToBig9Format } from '../state/helpers';
import CouponFooter from './CouponFooter';
import BetslipHeader from 'features/Betslip/BetslipHeader';
import CouponResults from 'features/SpilKlub/components/CouponResults';

const Coupons = ({
    coupons = [],
    poolHash,
    pool,
    isPoolOwner,
    refetchPoolDetails,
}) => {
    const finishedCoupon = !['OPEN', 'CREATED', 'PENDING'].includes(
        pool?.status
    );

    return (
        <>
            <div className={'top-indent-md'}>
                {coupons.some((coupon) => !coupon.betWasPlaced) && (
                    <>
                        <div className="sk-title top-indent-md bottom-indent-lg">
                            Udkast til kupon
                        </div>
                        <div className="fs-14 lh-20 font-thick bottom-indent-md">
                            Kaptajnenens udkast til kuponen vises nedenfor. Vær
                            opmærksom på, at kaptajnen derfor løbende kan ændre
                            i kuponen. Når kuponen er spillet, vil den fremgå
                            under kuponen.
                        </div>
                    </>
                )}
            </div>

            {coupons
                .sort(
                    (couponA, couponB) =>
                        couponA.couponId < couponB.couponId ? -1 : 1
                )
                .map((coupon, index) => {
                    return (
                        <div
                            className="fade-in bottom-divider"
                            style={{
                                marginBottom:
                                    coupons.length - 1 === index && 15,
                            }}
                            key={coupon.couponId}
                        >
                            {coupon.selections.map((selection) => (
                                <TableContent
                                    key={selection.nr}
                                    item={{
                                        name: selection.info.eventName,
                                        nr: selection.nr,
                                        status: selection.info.status,
                                    }}
                                    outcomes={convertSelectionsToBig9Format(
                                        coupon.selections,
                                        false,
                                        coupon.betWasPlaced
                                    )}
                                    short
                                />
                            ))}
                            <div className="top-indent-sm bottom-indent-lg">
                                <BetslipHeader
                                    readOnly
                                    combinationCount={coupon.combinationCount}
                                    combinationPrice={coupon.combinationPrice}
                                />
                            </div>
                            <CouponFooter
                                coupon={coupon}
                                poolHash={poolHash}
                                pool={pool}
                                finishedCoupon={finishedCoupon}
                                isPoolOwner={isPoolOwner}
                                refetchPoolDetails={refetchPoolDetails}
                            />
                            {finishedCoupon && (
                                <CouponResults coupon={coupon} />
                            )}
                        </div>
                    );
                })}
        </>
    );
};

export default Coupons;
